<template>

    <Head>
        <title>{{ categoria.nombre }}</title>
    </Head>
    <div class="hero-img-overlay " style="background-image: url(/img/hero-comisiones.png);">
        <div class="container">
            <div class="row">
                <div class="col-md-6 col-lg-7">
                    <h1 class="hero-encabezado">Información Pública</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="bloque-general">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h2 class="encabezado-separador"><span>{{ categoria.nombre }}</span></h2>
                </div>
            </div>
            <div>

                <div class="tabla-container mb-4" v-if="subcategorias.length < 1">
                    <table>
                        <tbody>
                            <tr v-for="(item, index) in archivos" :key="index">
                                <td class="nombre">{{ item.nombre }}</td>
                                <td width="220" class="boton">
                                    <a :href="route('informacion-publica.download', { item: item.id, categoria_slug: categoria.slug }) + '?' + Math.ceil(Math.random() * 1000000)" target="_blank" class="boton-secundario boton-flecha">Descargar</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div v-for="(subcategoria, index) in subcategorias" :key="index">
                    <div class="container text-center mt-5 mb-5">
                        <h2>{{ subcategoria.nombre }}</h2>
                    </div>

                    <div class="tabla-container">
                        <table>
                            <tbody>
                                <tr v-for="(item, index) in subcategoria.archivos" :key="index">
                                    <td class="nombre">{{ item.nombre }}</td>
                                    <td width="220" class="boton">
                                        <a :href="route('informacion-publica.download', { item: item.id, categoria_slug: categoria.slug }) + '?' + Math.ceil(Math.random() * 1000000)" target="_blank" class="boton-secundario boton-flecha">Descargar</a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div v-if="subcategorias.length < 1 && archivos.length < 1">
                    <div class="container text-center">
                        <h3>No hay archivos disponibles</h3>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faFolderOpen } from '@fortawesome/free-regular-svg-icons'
library.add(faFolderOpen);

export default {
    props: {
        categoria: Object,
        subcategorias: Object,
        archivos: Object,
    }
}
</script>
<style scoped>
.boton-secundario {
    padding: 5px 10px;
    font-size: 15px;
}

h2 {
    line-height: 1.3em;
}

@media (max-width: 576px) {
    .nombre {
        display: block;
        width: 350px;
    }

    .boton {
        display: block;
        padding-top: 0px;
    }
}
</style>
